import { createAction } from 'redux-actions'

import { ACTION_TYPES } from 'common/store/auth/constants'

export const openLogin = createAction(ACTION_TYPES.OPEN_LOGIN)

export const closeLogin = createAction(ACTION_TYPES.CLOSE_LOGIN)
